// extracted by mini-css-extract-plugin
export default {"CustomCheckbox":"MBAuXUG6"};